import React from "react"
import { withTheme } from "emotion-theming"

const Menu = ({ theme, colour }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="38"
    height="31"
    viewBox="0 0 38 31"
  >
    <path
      fill={colour ? colour : theme.colours.secondary}
      d="M0 26h38v5H0zM0 13h38v5H0zM0 0h38v5H0z"
    />
  </svg>
)

export default withTheme(Menu)
